/* 🤖 this file was generated by svg-to-ts */
export const mgcIconTriangleFilled: {
  name: 'triangle-filled';
  data: string;
} = {
  name: 'triangle-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.597 2.452a1.518 1.518 0 0 0-.699.438c-.219.254-8.886 15.285-8.963 15.547a1.484 1.484 0 0 0-.047.525c.032.552.331.985.862 1.246l.268.132 8.801.011c6.218.008 8.878-.001 9.064-.032.47-.078.89-.393 1.103-.827.139-.286.173-.738.079-1.055-.04-.136-1.702-3.056-4.438-7.797-3.459-5.996-4.414-7.622-4.57-7.782a1.39 1.39 0 0 0-.973-.442 1.79 1.79 0 0 0-.487.036"/></svg>`
};
